<template>
  <b-col :lg="size">
    <b-card no-body v-if="competition">
      <b-card-header>
        <h3 class="mb-0 d-flex"><i class="fas text-gold fa-trophy fa-2x"></i> <span class="ml-3 mt-1">{{ competition.name }} Leaderboard</span></h3>
      </b-card-header>
      <b-list-group class="my--3 scoreboard" v-if="scoreboard.length > 0">
        <b-list-group-item
            v-for="(user, index) in scoreboard"
            :key="index"
        >
          <b-row align-v="center">
            <b-col cols="auto">
              <a href="" class="avatar rounded-circle" style="max-width:40px; max-height: 40px;">
                <b-img :alt="user.name" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + user.avatar" />
              </a>
            </b-col>
            <b-col class="ml--2">
              <h4 class="mb-0">
                {{user.name}}<br>
                <b-badge variant="gold" pill>{{ user.score }}</b-badge>
              </h4>
            </b-col>
            <b-col cols="auto">
              <!-- Avatar -->
              <span class="fa-stack" v-if="index == 0">
                <i class="fa-solid text-gold fa-certificate fa-stack-2x"></i>
                <i class="far fa-1 fa-stack-1x fa-inverse"></i>
              </span>
              <span class="fa-stack" v-else-if="index == 1">
                <i class="fas text-silver fa-certificate fa-stack-2x"></i>
                <i class="far fa-2 fa-stack-1x fa-inverse"></i>
              </span>
              <span class="fa-stack" v-else-if="index == 2">
                <i class="fas text-bronze fa-certificate fa-stack-2x"></i>
                <i class="far fa-3 fa-stack-1x fa-inverse"></i>
              </span>
              <span class="fa-stack" v-else>
                <i class="fas fa-certificate fa-stack-2x"></i>
              </span>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group> 
      <!-- <b-list-group class="scoreboard" v-if="scoreboard.length > 0" flush>
        <b-list-group-item v-for="(user, index) in scoreboard" :key="index" class="d-flex justify-content-between align-items-center">
          <div>
            <span class="fa-stack" v-if="index == 0">
              <i class="fa-solid text-gold fa-certificate fa-stack-2x"></i>
              <i class="far fa-1 fa-stack-1x fa-inverse"></i>
            </span>
            <span class="fa-stack" v-else-if="index == 1">
              <i class="fas text-silver fa-certificate fa-stack-2x"></i>
              <i class="far fa-2 fa-stack-1x fa-inverse"></i>
            </span>
            <span class="fa-stack" v-else-if="index == 2">
              <i class="fas text-bronze fa-certificate fa-stack-2x"></i>
              <i class="far fa-3 fa-stack-1x fa-inverse"></i>
            </span>
            <span class="fa-stack" v-else>
              <i class="fas fa-certificate fa-stack-2x"></i>
            </span>
            <span class="avatar avatar-sm mr-3">
              <img :alt="user.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + user.avatar">
            </span>
            {{ user.name }}
          </div>
          <b-badge variant="gold" pill>{{ user.score }}</b-badge>
        </b-list-group-item>
      </b-list-group> -->
      <b-card-body v-else>
        <h4 class="text-center text-danger">No Competitors registered yet.</h4>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    competition: null,
    scoreboard: null,
    size: null,
    owner: null
  }
}
</script>
<style lang="scss">
  .text-gold {
    color: #FFD700;
  }
  .text-silver {
    color: #C0C0C0;
  }
  .text-bronze {
    color: #CD7F32;
  }
  .badge-gold {
      background-color: transparent;
      border: 1px solid #FFD700;
  }
  .scoreboard {
    max-height: 469px;
    overflow-y: auto;
  }
</style>